import React from 'react';
import InterventionLog from './interventionLog';
import { useParams } from 'react-router-dom';

export default function OneInterventionLog() {
  let { id } = useParams();

  return <InterventionLog incidentId={id} />;
}
